import { SEO_DESCRIPTION_HOMEPAGE, SEO_TITLE_HOMEPAGE } from 'mk/autogenerated/translations/HomePage.c7450067356077f5df21ca02a937b93d'
import { analyticsStoreEvent } from 'mk2/actions';
import { PostEntity, TopicEntity } from 'mk2/apps/forum/schemas';
import AddMenu from 'mk2/apps/home/containers/AddMenu/AddMenu';
import Home from 'mk2/apps/home/containers/Home/Home';
import { homeLoad, homeLoadPage, homeSuggestArticle } from 'mk2/apps/home/containers/Home/Home.actions';
import reducer, { BazaarCounts } from 'mk2/apps/home/containers/Home/Home.reducers';
import saga from 'mk2/apps/home/containers/Home/Home.sagas';
import {
    getHomeContestPosts,
    getHomeContestTopic,
    getHomeCounsellings,
    getHomeForumPosts,
    getHomePhotoblogPosts,
    getHomePosts,
    getHomeState,
    getHomeStrollers,
    getHomeWikiExperiences,
} from 'mk2/apps/home/containers/Home/Home.selectors';
import HomeRight from 'mk2/apps/home/containers/Home/HomeRight';
import { HomeCounsellingEntity, HomePhotoblogPostEntity, HomePostEntity } from 'mk2/apps/home/schemas';
import { StrollerMinEntity } from 'mk2/apps/strollers/schemas';
import { ExperienceEntity } from 'mk2/apps/wiki/schemas';
import { abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { showWarningToastAction } from 'mk2/helpers/toasts';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps } from 'mk2/pages/Page';
import { AppState, getRequestDeviceMobile, getRequestPermissions, getRequestUser } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { Store } from 'mk2/store/configureStore';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import styles from './HomePage.mscss';

interface OwnProps {}

interface StateProps {
    loadingState: LoadingState;
    errorMessage: string;
    pageLoadingState: LoadingState;
    pageErrorMessage: string;
    homePosts: HomePostEntity[];
    forumPosts: PostEntity[];
    contestPosts: PostEntity[];
    contestTopic: TopicEntity;
    wikiExperiences: ExperienceEntity[];
    photoblogPosts: HomePhotoblogPostEntity[];
    nextPage: number | null;
    bazaarCounts: BazaarCounts;
    requestUser: UserEntity;
    strollers: StrollerMinEntity[];
    counsellings: HomeCounsellingEntity[];
    lastVisitCountFriends: string | null;
    mobile: boolean;
    requestUserPermissions: string[];
    forumPostsVariant: ABState;
}

interface DispatchProps {
    onLoad();
    onLoadPage(page: number);
    onLoadAB();
    onStoreEvent(name: string, props: any, redirect?: string);
    onShowWarningToast(message: string | React.ReactNode);
    onSuggestArticle();
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class HomePage extends Page<OwnProps, StateProps, DispatchProps> {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const homeState = getHomeState(state);

            return {
                loadingState: homeState.loadingState,
                errorMessage: homeState.errorMessage,
                pageLoadingState: homeState.pageLoadingState,
                pageErrorMessage: homeState.pageErrorMessage,
                homePosts: getHomePosts(state),
                forumPosts: getHomeForumPosts(state),
                contestPosts: getHomeContestPosts(state),
                contestTopic: getHomeContestTopic(state),
                wikiExperiences: getHomeWikiExperiences(state),
                photoblogPosts: getHomePhotoblogPosts(state),
                nextPage: homeState.nextPage,
                bazaarCounts: homeState.bazaarCounts,
                requestUser: getRequestUser(state),
                strollers: getHomeStrollers(state),
                counsellings: getHomeCounsellings(state),
                lastVisitCountFriends: homeState.lastVisitCountFriends,
                mobile: getRequestDeviceMobile(state),
                requestUserPermissions: getRequestPermissions(state),
                forumPostsVariant: getABVariant(state, 'homepage_forum_posts_first'),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: homeLoad,
            onLoadPage: homeLoadPage,
            onStoreEvent: analyticsStoreEvent,
            onSuggestArticle: homeSuggestArticle,
            onShowWarningToast: showWarningToastAction,
            onLoadAB: () => abFetch('homepage_forum_posts_first'),
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_HOMEPAGE;
    }

    public getMetaDescription(props: Props): string {
        return SEO_DESCRIPTION_HOMEPAGE;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Home {...props} />
        );
    }

    public hasMobileLogo(props: Props): boolean {
        return true;
    }

    public getHeaderRight(props: Props): React.ReactNode {
        return props.mobile ? <AddMenu className={styles.HomePage__header__menu} /> : null;
    }

    public renderRight(props: Props): JSX.Element | null {
        return (
            <HomeRight {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Homepage - Branding',
        };
    }

    public registerInStore(store?: Store<AppState>) {
        if (!store) {
            return;
        }

        // sync registering
        const key = 'containers.home.home';
        store.injectReducer(key, reducer);
        store.injectSaga(key, saga);
        return null;
    }
}
